import { createSlice, PayloadAction } from "@reduxjs/toolkit";
 
interface ChatUIState {
  isOpen: boolean;
}
 
const initialState: ChatUIState = {
  isOpen: false,
};
 
const chatUISlice = createSlice({
  name: "chatUI",
  initialState,
  reducers: {
    setChatOpen(state, action: PayloadAction<boolean>) {
      state.isOpen = action.payload;
    },
    openChat(state) {
      state.isOpen = true;
    },
    closeChat(state) {
      state.isOpen = false;
    },
    toggleChat(state) {
      state.isOpen = !state.isOpen;
    },
  },
});
 
export const { setChatOpen, openChat, closeChat, toggleChat } =
  chatUISlice.actions;
export default chatUISlice.reducer;
 